import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play } from 'lucide-react';
import Spline from '@splinetool/react-spline';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-background">
        <Spline 
          scene="https://prod.spline.design/dLld3WCEjevzYgrD/scene.splinecode"
          onLoad={() => console.log('Spline scene loaded successfully')}
          onError={(error) => console.error('Spline error:', error)}
          style={{ 
            width: '100%', 
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0
          }}
        />
      </div>
      
      <div className="container">
        <div className="hero-content">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-text"
          >
            <h1 className="hero-main-title">
              Next-Gen <span className="saas-gradient">SaaS Solutions</span>
              <br />for Modern Enterprises
            </h1>
            
            
            <div className="hero-actions">
              <a href="#contact" className="btn-primary">
                Start Your Journey <ArrowRight size={20} />
              </a>
              <button className="btn-secondary demo-btn">
                <Play size={20} /> Watch Demo
              </button>
            </div>
          </motion.div>
          
          
        </div>
      </div>
    </section>
  );
};

export default Hero;
